{
  "title": "Asteroid Atlas",
  "loading": {
    "progress": "Cargando la Tierra..."
  },
  "navigation": {
    "title": "Navegar a Coordenadas",
    "latitude": "Lat:",    "overpressure_zone": "Onda de Choque (0.5 kPa / 0.07 psi)",
    "wind_zone": "Ráfaga de Viento (10 m/s / 22 mph)",
    "seismic_zone": "Sísmico (Meff 7.0)",  "longitude": "Lon:",
    "latitude_placeholder": "Latitud",
    "longitude_placeholder": "Longitud",
    "go_to_location": "Ir a Ubicación",
    "add_marker": "Añadir Marcador",
    "my_location": "📍 Mi Ubicación",
    "quick_locations": "Ubicaciones Rápidas:",
    "click_instruction": "Haga clic en la Tierra para obtener coordenadas en ese punto"
  },
  "locations": {
    "london": "Londres",
    "tokyo": "Tokio",
    "washington": "Washington",
    "new_york": "Nueva York",
    "paris": "París",
    "rio_de_janeiro": "Río de Janeiro",
    "cairo": "El Cairo",
    "mumbai": "Bombay",
    "moscow": "Moscú",
    "cape_town": "Ciudad del Cabo",
    "beijing": "Pekín",
    "los_angeles": "Los Ángeles",
    "dubai": "Dubái",
    "singapore": "Singapur",
    "reykjavik": "Reikiavik",
    "greenwich": "Greenwich (0°,0°)",
    "null_island": "Isla Null (0°,0°)"
  },
  "countries": {
    "united_states": "Estados Unidos",
    "united_kingdom": "Reino Unido",
    "japan": "Japón",
    "australia": "Australia",
    "france": "Francia",
    "brazil": "Brasil",
    "egypt": "Egipto",
    "india": "India",
    "russia": "Rusia",
    "south_africa": "Sudáfrica",
    "china": "China",
    "united_arab_emirates": "Emiratos Árabes Unidos",
    "singapore": "Singapur",
    "iceland": "Islandia",
    "canada": "Canadá",
    "germany": "Alemania",
    "italy": "Italia",
    "spain": "España",
    "mexico": "México",
    "argentina": "Argentina",
    "chile": "Chile",
    "peru": "Perú",
    "colombia": "Colombia",
    "venezuela": "Venezuela",
    "norway": "Noruega",
    "sweden": "Suecia",
    "finland": "Finlandia",
    "denmark": "Dinamarca",
    "netherlands": "Países Bajos",
    "belgium": "Bélgica",
    "switzerland": "Suiza",
    "austria": "Austria",
    "poland": "Polonia",
    "czech_republic": "República Checa",
    "hungary": "Hungría",
    "romania": "Rumania",
    "bulgaria": "Bulgaria",
    "greece": "Grecia",
    "turkey": "Turquía",
    "israel": "Israel",
    "saudi_arabia": "Arabia Saudí",
    "iran": "Irán",
    "iraq": "Irak",
    "afghanistan": "Afganistán",
    "pakistan": "Pakistán",
    "bangladesh": "Bangladés",
    "sri_lanka": "Sri Lanka",
    "myanmar": "Myanmar",
    "thailand": "Tailandia",
    "vietnam": "Vietnam",
    "cambodia": "Camboya",
    "laos": "Laos",
    "malaysia": "Malasia",
    "indonesia": "Indonesia",
    "philippines": "Filipinas",
    "south_korea": "Corea del Sur",
    "north_korea": "Corea del Norte",
    "mongolia": "Mongolia",
    "kazakhstan": "Kazajistán",
    "uzbekistan": "Uzbekistán",
    "kyrgyzstan": "Kirguistán",
    "tajikistan": "Tayikistán",
    "turkmenistan": "Turkmenistán",
    "ukraine": "Ucrania",
    "belarus": "Bielorrusia",
    "lithuania": "Lituania",
    "latvia": "Letonia",
    "estonia": "Estonia",
    "new_zealand": "Nueva Zelanda",
    "papua_new_guinea": "Papúa Nueva Guinea",
    "fiji": "Fiyi",
    "somalia": "Somalia",
    "ethiopia": "Etiopía",
    "kenya": "Kenia",
    "tanzania": "Tanzania",
    "uganda": "Uganda",
    "rwanda": "Ruanda",
    "democratic_republic_of_the_congo": "República Democrática del Congo",
    "angola": "Angola",
    "zambia": "Zambia",
    "zimbabwe": "Zimbabue",
    "botswana": "Botsuana",
    "namibia": "Namibia",
    "madagascar": "Madagascar",
    "mauritius": "Mauricio",
    "seychelles": "Seychelles",
    "morocco": "Marruecos",
    "algeria": "Argelia",
    "tunisia": "Túnez",
    "libya": "Libia",
    "sudan": "Sudán",
    "chad": "Chad",
    "niger": "Níger",
    "mali": "Malí",
    "burkina_faso": "Burkina Faso",
    "ghana": "Ghana",
    "ivory_coast": "Costa de Marfil",
    "nigeria": "Nigeria",
    "cameroon": "Camerún",
    "gabon": "Gabón",
    "central_african_republic": "República Centroafricana"
  },
  "regions": {
    "africa": "África",
    "europe": "Europa",
    "asia": "Asia",
    "north_america": "América del Norte",
    "south_america": "América del Sur",
    "oceania": "Oceanía",
    "antarctica": "Antártida",
    "middle_east": "Oriente Medio",
    "caribbean": "Caribe",
    "central_america": "América Central",
    "eastern_europe": "Europa Oriental",
    "western_europe": "Europa Occidental",
    "northern_europe": "Europa del Norte",
    "southern_europe": "Europa del Sur",
    "southeast_asia": "Sudeste Asiático",
    "east_asia": "Asia Oriental",
    "south_asia": "Asia del Sur",
    "central_asia": "Asia Central",
    "western_asia": "Asia Occidental",
    "northern_africa": "África del Norte",
    "eastern_africa": "África Oriental",
    "western_africa": "África Occidental",
    "southern_africa": "África Austral",
    "central_africa": "África Central"
  },
  "coordinates": {
    "format": "{{lat}}°, {{lon}}°",
    "clicked": "Coordenadas del clic: {{lat}}, {{lon}}",
    "your_location": "Su ubicación: {{lat}}, {{lon}} (±{{accuracy}}m)",
    "found_location": "¡Ubicación encontrada!\\nCoordenadas: {{lat}}°, {{lon}}°",
    "found_location_region": "¡Ubicación encontrada en {{region}}!\\nCoordenadas: {{lat}}°, {{lon}}°",
    "latitude": "Latitud",
    "longitude": "Longitud",
    "region": "Región",
    "distance_to_target": "Distancia al objetivo",
    "north": "N",
    "south": "S",
    "east": "E",
    "west": "O"
  },
  "measurements": {
    "kilometers": "km",
    "meters": "m",
    "accuracy": "±{{value}}m"
  },
  "errors": {
    "geolocation_not_supported": "La geolocalización no es compatible con este navegador.",
    "location_permission_denied": "Acceso a la ubicación denegado por el usuario.",
    "location_unavailable": "La información de ubicación no está disponible.",
    "location_timeout": "La solicitud de ubicación agotó el tiempo de espera.",
    "location_unknown": "Ocurrió un error desconocido al obtener la ubicación.",
    "invalid_coordinates": "Por favor ingrese valores válidos de latitud y longitud",
    "location_lookup_failed": "Error al buscar ubicación"
  },
  "ui": {
    "language": "Idioma",
    "select_language": "Seleccionar Idioma",
    "impact_zones": "Zonas de Impacto",
    "impact_energy": "Energía de Impacto",
    "crater_zone": "Cráter (100% destrucción)",
    "fireball_zone": "Bola de Fuego (50% mortalidad)",
    "overpressure_zone": "Onda de Choque (5 kPa / 0.7 psi)",
    "wind_zone": "Ráfaga de Viento (40 m/s / 90 mph)",
    "seismic_zone": "Sísmico (Meff 7.0)",
    "impact_location": "Ubicación del Impacto"
  },
  "info": {
    "asteroid_info": "Información del Asteroide",
    "earth_info": "Información de la Tierra",
    "loading_data": "Cargando datos..."
  }
}